<div class="row signup-container justify-content-center mr-0 ml-0">
  <ng-container *ngIf="currentStep === 1">
    <div class="d-none d-md-flex col-md-4 pl-0 pr-4">
        <div class="left-sidebar">
          <div class="title">
            <app-icon-paybee-text></app-icon-paybee-text>
          </div>
          <div class="description">
            The All-in-One Fundraising Platform.
          </div>
          <div class="bottom-logo">
            <app-icon-paybee-logo></app-icon-paybee-logo>
          </div>
        </div>
    </div>
  </ng-container>

  <div class="col ">
    <div class="row container-md justify-content-center mr-auto ml-auto">
      <div class="col-12">
        <div class="row header align-items-center pr-3 pl-3">
          <ng-container *ngIf="currentStep > 1 else nextSteps">
            <div class="col-3">
              <img src="/images/logo.png" class="img-fluid flex-center">
            </div>
          </ng-container>
          <ng-template #nextSteps>
            <div class="col-3 d-flex d-md-none">
              <img src="/images/logo.png" class="img-fluid flex-center">
            </div>
          </ng-template>
          <div class="col support text-right">
            <div class="menu-item">
              <span>Need help? </span>
            </div>

            <div class="menu-item">
              <span (click)="onSupport()" class="help purple-link">Get Help</span>
            </div>

            <div class="menu-item" *ngIf="(currentStep > 1) || showLogoutLink">
              <span (click)="onLogout()" class="help">Logout</span>
            </div>
          </div>
        </div>
        <div class="row justify-content-center ml-3 mr-3">
          <ng-container *ngIf="currentStep > 1">
            <div #scrollMenu class="col-12 col-sm-4 steps d-flex flex-row flex-sm-column">
              <ng-container *ngFor="let step of steps">
                <div [id]="step.id" [ngClass]="{'active': (step.id === currentStep)}" class="row step align-items-center">
                  <div class="col-12">
                    <ng-container *ngIf="(step.id < currentStep); else prevSteps" >
                      <div class="step-finished">
                        <app-icon-checkmark></app-icon-checkmark>
                      </div>
                    </ng-container>
                    <ng-template #prevSteps>
                      <div class="step-number" [ngClass]="{'active': (step.id === currentStep)}" [innerText]="step.id"></div>
                    </ng-template>
                    <span [innerText]="step.name"></span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="col-12 col-sm-8 mb-3">
            <ng-container [ngSwitch]="currentStep">
              <app-signup01 *ngSwitchCase="1"></app-signup01>
              <app-signup02 *ngSwitchCase="2"></app-signup02>
              <app-signup03 *ngSwitchCase="3"></app-signup03>
              <app-signup04 *ngSwitchCase="4"></app-signup04>
              <app-signup05 *ngSwitchCase="5"></app-signup05>
              <app-signup06 *ngSwitchCase="6"></app-signup06>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<app-dialog></app-dialog>
<app-loading></app-loading>
<app-mdb-toast></app-mdb-toast>